module.exports = __webpack_public_path__ + "img/elantra5.bbc5c68a.jpeg";